var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tool-index text-options"},[_c('div',{staticClass:"tool-section"},[_c('section',{staticClass:"tool-option vertical"},[_c('div',[_vm._v(_vm._s(_vm.getTitle))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }